// extracted by mini-css-extract-plugin
export default {"canvasBorder":"teams-create_canvasBorder__PdV0b","usersPlaceHolder":"teams-create_usersPlaceHolder__DH7Jq","userListContainer":"teams-create_userListContainer__-Pc8G"};